import React from 'react'
import AssessmentModule from '../AssesmentModule/AssesmentModule'
import { Route, Routes, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AlertSaveButton from '../../../button/AlertSaveButton'
import SelectCurriculum from '../../../SelectCurriculum/SelectCurriculum'
import List from './List/List'
import { updateSubjectForm } from '../../../../store/actions/subjects.actions'
import Create from './Create/Create'
import Edit from './Edit/Edit'
import Module from '../../../layout/Module'
import NotFoundPage from '../../../NotFoundPage/NotFoundPage'

const Subject = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const curriculumId = params['*']?.split('/')[0]
  const permissions = useSelector((state) => state?.session?.permissions?.subject || {})

  const onRedirect = (redirectTo) => {
    navigate(`/dashboard/subjects/${curriculumId}${redirectTo}`)
  }

  return (
    <AssessmentModule
      moduleName="subject"
      title="Subjects"
      titleLink="/dashboard/subjects"
      actions={<>
        { permissions?.created && curriculumId && (
          <AlertSaveButton
            submodule='Subjects'
            icon='th-list'
            title='List'
            color='secondary'
            onDontSave={() => {
              onRedirect('')
            }}
          />
        )}
        { permissions?.created && curriculumId && (
          <AlertSaveButton
            submodule='Subjects'
            icon='plus'
            title='Create'
            color='secondary'
            onDontSave={() => {
              dispatch(updateSubjectForm({ curriculumId: curriculumId }))
              onRedirect('/create')
            }}
          />
        )}
      </>}
    >
      <Routes>
        <Route path="/" element={<SelectCurriculum />} />
        <Route index path="/:curriculumId" element={<List />} />
        <Route path="/:curriculumId/create" element={<Create />} />
        <Route path="/:curriculumId/edit/:id" element={<Edit />} />
        <Route
          path='*'
          element={
            <Module.BodyFullContainer className='flex justify-center items-center'>
              <NotFoundPage />
            </Module.BodyFullContainer>
          } 
        />
      </Routes>
    </AssessmentModule>
  )
}

export default Subject